export const verificationEmailColor = '#8E8E8E';
export const activeTypeColor = '#53ADCB';
export const inactiveTypeColor = '#C7C7C7';
export const successColor = 'green';
export const offWhiteColor = '#E9F5F8';
